import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { combineLatest } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { CampaignStatus } from '../../core/constants/lookups';
import { CampaignOpen } from '../../core/data/campaign';
import { CampaignCapWindowService } from '../../core/data/campaign-cap-window-service';
import { CampaignService } from '../../core/data/campaign-service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ss-campaign-complete-edit',
    templateUrl: './campaign-complete-edit.component.html',
    styles: [
        `
            .kendo-dialog-body {
                margin-left: 5%;
                margin-right: 5%;
                margin-top: 5%;
                margin-bottom: 5%;
            }
        `
    ]
})
export class CampaignCompleteEditComponent {

    @Input() showSuccessToastr = false;
    private goalAmountControl = 'goalAmount';
    campaignOpenForm: UntypedFormGroup = new UntypedFormGroup({
        goalAmount: new UntypedFormControl(0),
        endDate: new UntypedFormControl(null, Validators.required),
        campaignId: new UntypedFormControl(0)
    });
    get endDt() {
        return this.campaignOpenForm.get('endDate');
    }

    vm$ = combineLatest([this.campaignService.campaignCompleteEdit$, this.capWindowService.getCapAmount()])
        .pipe(
            map(([edit, capAmount]) => ({
                edit,
                capAmount,
                endDateMin: new Date(new Date().toLocaleDateString())
            })),
            tap((vm) => {
                this.campaignOpenForm.controls[this.goalAmountControl]
                    .setValidators([
                        Validators.required,
                        Validators.min(1),
                        Validators.max(vm.capAmount)]);

                if (vm.edit)
                    this.campaignOpenForm.setValue({
                        goalAmount: vm.edit.goal,
                        endDate: new Date(vm.edit.endDate),
                        campaignId: vm.edit.campaignId
                    });
                this.campaignOpenForm.markAllAsTouched();
            }),
        );

    constructor(
        private campaignService: CampaignService,
        private capWindowService: CampaignCapWindowService,
        private toastrService: ToastrService) { }

    closeModal = () => this.campaignService.campaignCompleteEdit$.next(null);

    openCampaign = () => {
        let campaign = new CampaignOpen();
        campaign = { ... this.campaignOpenForm.getRawValue() };
        this.campaignService.openCampaign(campaign).subscribe(() => {
            this.campaignService.setCampaignsState(this.campaignService.defaultState);
            this.campaignService.setCampaignsStatus(CampaignStatus.Completed);

            this.toastrService.success('Your changes has been saved.');
            this.closeModal();
        });
    }

}
